import {storePersistKey} from "./Constant";

export function getLocalToken() {
  let token = ""
  let data = document.cookie.split(";")
  for(let i=0;i<data.length;i++){
    let res = data[i].split("=")
    if(res[0].trim() == "token"){
      token = res[1]
      break;
    }
  }
  if (localStorage[storePersistKey] && token != "") {
    if(JSON.parse(localStorage[storePersistKey]) != undefined){
      const data = JSON.parse(localStorage[storePersistKey]);
      if (data.userStore && data.userStore.token && data.userStore.token.length > 0) {
        return data.userStore.token;
      }
    }

  }
  return '';
}

export function clearLocalToken() {
  document.cookie =  'token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  localStorage.removeItem(storePersistKey)

  var cookies = document.cookie.split("; ");
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=; domain=.nxtt.org.cn; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
  return '';
}
